module.exports = require('./helpers/bundle-url').getBundleURL('8GXGR') + "logo.7718c6df.svg";